import { IUserSubscription } from '@interfaces/fc-payment/subscriptions'
import { SubscriptionTypeI } from '@interfaces/finance/general'
import SessionDataI from '@interfaces/redux/sessionI'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialData: SessionDataI = {
    username: null,
    userId: null,
    email: null,
    loggedIn: false,
    roles: [],
    orgRoles: ["OSA", "PR"],
    /**
     * @deprecated
     */
    isPremium: false,
    appOrigin: null,
    plan: null,
    originSegments: [],
    subscriptionType: null
}

export const sessionSlice = createSlice({
    name: "session",
    // initial session state as SessionDataI interface model
    initialState: initialData,
    reducers: {
        /**
         * @param current state
         * @param action payload with new data to update state
         */
        setAuth: (state, action: PayloadAction<SessionDataI>) => {
            state.email = action.payload.email
            state.userId = action.payload.userId
            state.username = action.payload.username
            state.roles = action.payload.roles
            state.loggedIn =  true
            state.orgRoles = action.payload.orgRoles?? ["OSA"]
            state.appOrigin = action.payload.appOrigin
        },
        /**
         * @deprecated 
         */
        setPremium: (state, action: PayloadAction<{isPremium: boolean}>) => {
            state.isPremium = action.payload.isPremium
        },
        setSubscription: (state, action: PayloadAction<IUserSubscription | null>) => {
            state.plan = action.payload
        },
        clearSubscription: (state) => {
            state.isPremium = false
            state.plan = null
        },
        setSessionSegments: (state, action: PayloadAction<string[]>) => {
            state.originSegments = action.payload
        },
        setSubscriptionType: (state, action: PayloadAction<SubscriptionTypeI | null>) => {
            state.subscriptionType = action.payload
        },
        /**
         * Clean session slice
         */
        logOut: (state) => {
            state.email = null
            state.userId = null
            state.username = null
            state.roles = []
            state.loggedIn =  false
            state.appOrigin = null
            state.isPremium = false
            state.plan = null
            state.originSegments = []
            state.subscriptionType = null
        },
    },
})

export const { setAuth, logOut, setPremium, setSubscription, clearSubscription, setSessionSegments, setSubscriptionType } = sessionSlice.actions
export default sessionSlice.reducer
